/*
 * @Description: 首页应用位骨架
 * @Author: 蔺晨
 * @Date: 2020-12-11
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Shape from './Shape';
import { Flex } from 'antd-mobile';

// @withRouter
export default class ApplicationFrame extends Component {
  static propTypes = {
    amount: PropTypes.number
  };

  static defaultProps = {
    amount: 5
  };

  constructor(props, context) {
    super(props, context);
  }

  render() {
    const { amount } = this.props;
    return (
      <Flex style={{ padding: '20px 10px 10px', marginBottom: '30px' }}>
        {Object.keys([...new Array(amount)]).map((item) => {
          return (
            <Flex direction="column" align="center" justify="center" style={{ width: '20%' }}>
              <Shape type="circular" w="72px" h="72px" />
              <Shape type="square" w="88px" h="24px" margin="14px 0 0 0" />
            </Flex>
          );
        })}
      </Flex>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pubBiz/FrameWork/ApplicationFrame.js